export interface RequestFilters {
    search: string;
    request_number: string;
    requestor__name: string;
    pickup_location_id: string;
    dropoff_location_id: string;
    container_size_type_id: string;
    condition_id: string;
    request_type: string;
    request_date__gte: Date;
    request_date__lte: Date;
    external_reference_no: string;
    group_id: string;
    request_source:string;
    page_size: number;
    page: number;
    o: string;
}
export class RequestFiltersClass implements RequestFilters {
    search: string;
    request_number: string;
    requestor__name: string;
    pickup_location_id: string;
    dropoff_location_id: string;
    container_size_type_id: string;
    condition_id: string;
    request_type: string;
    request_date__gte: Date;
    request_date__lte: Date;
    external_reference_no: string;
    requestor__company: string;
    request_age_in_days: number;
    request_source:string;
    group_id: string;
    page_size: number;
    page: number;
    o: string;

    constructor() {
        this.search = null;
        this.request_number = null;
        this.requestor__name = null;
        this.pickup_location_id = null;
        this.dropoff_location_id = null;
        this.container_size_type_id = null;
        this.condition_id = null;
        this.request_type = '';
        this.request_date__gte = null;
        this.request_date__lte = null;
        this.external_reference_no = null;
        this.requestor__company = null;
        this.request_age_in_days = null;
        this.group_id = null;
        this.request_source = null;
        this.page_size = 10;
        this.page = 1;
        this.o = '';
    }
}

